import React from "react";
import { maxLength, required, TextInput } from "react-admin";
import RaInput from "../../components/inputs/RaInput";

const Single = ({ source, record, ...props }) => {
	return (
		<React.Fragment>
			<RaInput>
				<TextInput {...props} source="name" validate={maxLength(255)} />
			</RaInput>
			<RaInput>
				<TextInput {...props} source="remote_name" validate={maxLength(255)} />
			</RaInput>
			<RaInput>
				<TextInput
					{...props}
					source="remote_id"
					validate={[required(), maxLength(255)]}
				/>
			</RaInput>
		</React.Fragment>
	);
};

export default Single;
